export default {
  env:
    window.location.hostname === "localhost" ||
    window.location.hostname === "38.70.252.248"
      ? "development"
      : "production",
};
